import styled, { css } from 'styled-components'

import { useTranslation } from '@root/shared/localization'
import { CrossIcon, LogoGlass } from '@root/shared/ui-kit/icons'
import { mediaMaxMobile } from '@root/shared/ui-kit/theme'

type Props = {
  onClose: () => void
}

export const DownloadDialogHeader: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation()

  const handleClose = () => onClose()

  return (
    <Root>
      <LogoGlass size={36} />
      <Title>{t('app.name')}</Title>
      <CloseButton width={20} onClick={handleClose} />
    </Root>
  )
}

const Root = styled.header`
  display: grid;
  grid-template-columns: auto auto;

  height: 70px;
  gap: 10px;

  place-items: center;
  justify-content: center;
  align-items: center;

  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.04) 0%,
    rgba(255, 255, 255, 0.05) 57.92%
  );
  box-shadow: 0px 10px 40px 0px var(--appearanceA-4);
`

const Title = styled.h1`
  color: var(--text-12);
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -1px;
`

const CloseButton = styled(CrossIcon)`
  color: var(--textA-4);
  position: absolute;

  right: 15px;
  top: 15px;
  cursor: pointer;

  transition: all 100ms ease;
  z-index: 1;

  &:hover {
    color: var(--textA-9);
  }

  ${mediaMaxMobile(css`
    color: var(--textA-9);
  `)}
`
